import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import Navbar from './Navbar';
import './Dashboard.css';
import { FaCalendarAlt, FaCalendarDay, FaMinusCircle, FaUsers, FaUserCog, FaClipboardList, FaInfoCircle, FaQuestionCircle } from 'react-icons/fa';
import HelpModal from './HelpModal';

function Dashboard() {
  const navigate = useNavigate();
  const [userRole, setUserRole] = useState('');
  const [dashboardTitle, setDashboardTitle] = useState('');
  const [helpOpen, setHelpOpen] = useState(false);

  const dashboardTitles = [
    "¿Vas a pedir vacaciones? ¡Estas son las opciones disponibles para ti!",
    "Bienvenido al portal de vacaciones, aquí están tus opciones.",
    "¡Hola! Bienvenido a tu tablero de opciones :)",
    "¡Qué alegría verte de nuevo! Aquí están tus opciones.",
    "¿Planeando descansar? Estas son tus opciones disponibles.",
    "¿Sabías que WSP significa World-class Solution Provider?, tus opciónes son:",
    "Ya viene siendo hora de unas vacaciones, ¿no?, estas son tus opciónes:",
    "Alguien dijo... ¡¿Vacaciones?!, aquí están tus opciones:"
  ];

  useEffect(() => {
    getUserRole();
    const randomIndex = Math.floor(Math.random() * dashboardTitles.length);
    setDashboardTitle(dashboardTitles[randomIndex]);
  }, []);

  const getUserRole = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        const { data, error } = await supabase
          .from('users')
          .select('role')
          .eq('wsp_email', user.email)
          .single();

        if (error) throw error;
        setUserRole(data.role);
      }
    } catch (error) {
      console.error('Error fetching user role:', error.message);
    }
  };

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/');
  };

  return (
    <div className="dashboard">
      <Navbar />
      <div className="dashboard-content">
        <h1 className="dashboard-title">{dashboardTitle}</h1>
        <div className="button-container">

          {(userRole === 'admin' || userRole === 'RH') && (
            <button
              className="action-button"
              onClick={() => navigate('/registrar-vacaciones', { state: { mode: 'full' } })}
            >
              <FaCalendarAlt className="button-icon" />
              <span>Registrar Vacaciones (Días enteros)</span>
            </button>
          )}

          {(userRole === 'admin' || userRole === 'RH') && (
            <button
              className="action-button"
              onClick={() => navigate('/registrar-vacaciones', { state: { mode: 'half' } })}
            >
              <FaCalendarDay className="button-icon" />
              <span>Registrar Vacaciones (Medio día)</span>
            </button>
          )}

          {(userRole === 'admin' || userRole === 'RH') && (
            <button
              className="action-button"
              onClick={() => navigate('/remover-vacaciones')}
            >
              <FaMinusCircle className="button-icon" />
              <span>Remover un día de vacaciones a todos</span>
            </button>
          )}

          {(userRole === 'admin' || userRole === 'RH') && (
            <button
              className="action-button"
              onClick={() => navigate('/usuarios-empleados')}
            >
              <FaUsers className="button-icon" />
              <span>Administración de usuarios</span>
            </button>
          )}

          {userRole === 'admin' && (
            <button
              className="action-button admin-button"
              onClick={() => navigate('/admin-usuarios')}
            >
              <FaUserCog className="button-icon" />
              <span>Administración de gerencias</span>
            </button>
          )}

          {userRole !== 'admin' && (
            <button
              className="action-button"
              onClick={() => navigate('/solicitar-vacaciones')}
            >
              <FaClipboardList className="button-icon" />
              <span>Solicitar Vacaciones</span>
            </button>
          )}
          
          {userRole !== 'admin' && (
            <button
              className="action-button"
              onClick={() => navigate('/consultar-informacion')}
            >
              <FaInfoCircle className="button-icon" />
              <span>Consultar Información</span>
            </button>
          )}

          <button
            className="action-button help-button"
            onClick={() => setHelpOpen(true)}
          >
            <FaQuestionCircle className="button-icon" />
            <span>Necesito Ayuda</span>
          </button>
        </div>
        <div className="credit-text">Created by: Fernando Núñez for WSP International / Ver 1.1.5</div>
        <HelpModal isOpen={helpOpen} onClose={() => setHelpOpen(false)} />
      </div>
    </div>
  );
}

export default Dashboard;